// frontend-react/src/context/AuthContext.js (ΕΝΗΜΕΡΩΜΕΝΟ)

import React, { createContext, useState, useEffect, useCallback } from 'react';
import api, { getCurrentUser } from '../api/api';

export const AuthContext = createContext();
const LOCAL_EXECUTION = process.env.REACT_APP_LOCAL_EXECUTION === 'true';
const LOCAL_USER = {
    id: 1, username: 'Local Trader', email: 'local@algostock.local', role: 'user',
    is_active: true, bot_running: false, subscription_status: 'active',
    scanner_package_purchased_at: new Date().toISOString(), scanner_access: true, methodology_access: true,
    has_completed_onboarding: true, is_two_factor_enabled: false
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(LOCAL_EXECUTION ? LOCAL_USER : null);
    const [loading, setLoading] = useState(!LOCAL_EXECUTION);

    const fetchUser = useCallback(async () => {
        if (LOCAL_EXECUTION) {
            setUser(LOCAL_USER);
            setLoading(false);
            return;
        }
        const token = localStorage.getItem('authToken');
        if (token) {
            try {
                const response = await getCurrentUser();
                setUser(response.data);
            } catch (error) {
                console.error("Session expired or invalid token.", error);
                logout();
            }
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    // --- START OF FIX ---
    const login = async (token) => {
        if (LOCAL_EXECUTION) return;
        localStorage.setItem('authToken', token);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        await fetchUser(); // Reuse fetchUser to get user data
    };
    // --- END OF FIX ---

    const logout = () => {
        if (LOCAL_EXECUTION) return;
        localStorage.removeItem('authToken');
        delete api.defaults.headers.common['Authorization'];
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, loading, fetchUser, isLocalExecution: LOCAL_EXECUTION }}>
            {children}
        </AuthContext.Provider>
    );
};